<template>
    <footer class="bg-gray-100">
        <div class="max-w-screen-lg mx-4 lg:mx-auto px-4 py-12 border-t-2 border-white">
            <p class="text-center text-gray-500">© <router-link class="font-bold hover:underline" to="/">Ariel Works</router-link>. All Rights Reserved.</p>
        </div>
    </footer>
</template>